import styled from 'styled-components'


export const TableSelectUserWrapper = styled.div`
  .ant-table-row {
    cursor: pointer;
  }
`